import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { FunctionService} from 'vhobjects-service/src/services';

@Component({
  selector: 'app-search-snimei-config',
  templateUrl: './search-snimei-config.component.html',
  styleUrls: ['./search-snimei-config.component.scss']
})
export class AtwSearchSnimeiConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() device: any;
  @Input() blocks_of_page: any; // là dữ liệu staticdata từ database

  isCollapsed: boolean = false;
  isViewAll: boolean = false;
  currentViewAll: any = {};

  stylefields = [
    {
      title: 'dieu_chinh_bo_tron',
      index: 1,
    },
    {
      title: 'hieu_ung',
      index: 2,
    },
  ]

  arr_link_page: any = [];
  id_subproject: any = '';
  backgroundColor: any = [];
  fonts = [];
  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    public http: HttpClient,
    public functionService: FunctionService,
  ) {

  }

  ngOnInit(): void {
    forkJoin([
      this.http.get('assets/background-colors/background-colors.json'),
    ]).subscribe(([background_colors]: any) => {
      this.backgroundColor = background_colors;
    })
    
  }

  ngOnChanges(): void { }



  //Mở xem thêm
  openViewAll(field) {
    this.currentViewAll = field;
    this.isViewAll = !this.isViewAll;
  }

  // xử lý chỉ mở được 1 menu 1 lần
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false
  };
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

/**Hàm này dùng để click chọn màu nền của danh sách màu.
   * @param bgColor : trả về màu được chọn
   * @param event : trả về element được active
   */
  chooseBg(bgColor, event) {
    var activeGradient = document.querySelector('.container-color .active') as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');
    this.class[`search-snimei`]['background-color'] = bgColor.bgColor;
    this.updateClass();
  }
  // */ Hàm update object vào database.
  // */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
    
  }

  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })

  }

  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
     
  }
  
  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['search-snimei']['width'] = event.width + 'px';
    if (event.height) this.class['search-snimei']['height'] = event.height + 'px';
    this.updateClass();
  }

  /**
 * Cập nhật staticdata vào database.
 */
  updateStaticdata() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
     
  }

}
